import { defineComponent, computed, toRefs } from "@vue/composition-api";
import { capitalize } from "lodash";
import { useI18n } from "vue-i18n-composable";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { useAccountStoreGetters } from "@Broker/@Modules/main/store/account/account-helpers";
import * as AccountGetters from "@Broker/@Modules/main/store/account/account-getters";
import { useMultipleSelect } from "@Shared/@Composables/generic/useMultipleSelect";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
export default defineComponent({
  name: "SelectLevel",
  components: {
    MaterialInput,
    vSelectField
  },
  props: {
    selectedLevel: {
      type: [String, Array],
      required: true,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const {
      t,
      tc
    } = useI18n();
    const {
      selectedLevel,
      multiple
    } = toRefs(props);
    const {
      handleSelectMultipleChange
    } = useMultipleSelect();
    const {
      CURRENT_ACCOUNT_IS_BROKER
    } = useAccountStoreGetters([AccountGetters.CURRENT_ACCOUNT_IS_BROKER]);
    const levelOptions = computed(() => {
      const brokerOption = CURRENT_ACCOUNT_IS_BROKER.value ? [{
        id: "brokerage",
        text: capitalize(tc("global.doorr.brokerage", 1))
      }] : [];
      return [{
        id: "agent",
        text: capitalize(tc("global.doorr.agent", 1))
      }, ...brokerOption];
    });
    const localSelectedLevel = computed({
      get() {
        var _selectedLevel$value;
        return (_selectedLevel$value = selectedLevel.value) != null ? _selectedLevel$value : multiple.value ? [] : "";
      },
      set(newValue) {
        emit("update:selectedLevel", newValue);
      }
    });
    const options = computed(() => ({
      placeholder: t("global.actions.chooseOption")
    }));
    const handleChange = (selectedValue, type) => {
      localSelectedLevel.value = handleSelectMultipleChange(selectedValue, type, localSelectedLevel.value, multiple.value);
    };
    return {
      levelOptions,
      localSelectedLevel,
      options,
      handleChange
    };
  }
});